module.exports = __webpack_public_path__ + "img/bus-footer.7fe48875.png";